import { TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> { }

export function TextAreaField({ ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className="textArea-create-form-payload"
      style={{ textAlign: 'center', justifyContent: 'center' }}
    />
  )
}

export function TextAreaErrors({ ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className="textArea-errors"
    />
  )
}